import { AnimatedSpan } from "../../MotionMui/MotionMui"; // Adjust path if needed
import "./HelpText.css";
export interface HelpTextProps {
  children: any,
}

export const HelpTextComponent = (props: HelpTextProps) => {
  return (
    <AnimatedSpan className='help-text'>{props.children}</AnimatedSpan>
  );
}